import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackAuthenticationError = ({
  errorType,
  authMethod,
  errorMessage = '',
  couponCode = '',
  entryPoint = '',
  statusCode = null,
  userAgent = '',
}) => {
  const properties = {
    error_type: errorType,
    auth_method: authMethod,
    error_message: errorMessage,
    coupon_code: couponCode,
    entry_point: entryPoint,
    status_code: statusCode,
    user_agent: userAgent,
  }
  ga.track('authentication_error', properties)
  amplitude.track('system_error', {
    ...baseWebEventProps(),
    action_type: 'inactive',
    error_type: 'authentication_error',
    error_description: errorMessage || errorType,
    authentication_method: authMethod,
    coupon: couponCode,
    ...(entryPoint ? { event_source: entryPoint } : {}),
    user_agent: userAgent,
  })
}
